<template>
  <div class="page_diaobo_add">
    <van-nav-bar
      title="调拨出库"
      left-text="返回"
      left-arrow
      @click-left="back"
    />
    <van-form
      class="container"
      @submit="onSubmit"
      :show-error="false"
      :scroll-to-error="true"
    >
      <div class="content c1" :class="showType === 3 ? 'dis' : 'nodis'">
        <h3>1.任务信息</h3>
        <OrganSelect
          ref="OrganSelect"
          :required="true"
          label="归属单位："
          :showName="form.organName"
          v-model="form.organId"
          @change="
            (res) => {
              form.organName = res.title;
              $refs.emmSelect.initData(form);
            }
          "
        >
        </OrganSelect>
        <Select
          v-model="form.storageLevel"
          url="/system/dict/list/table"
          :params="{ code: 'ccdj' }"
          keys="code"
          showName="name"
          :required="true"
          label="物资储备级别："
          @change="
            (res) => {
              $refs.emmSelect.initData(form);
            }
          "
        >
        </Select>
        <van-field
          v-model="form.warehouseName"
          label="负责调运库点："
          readonly
        />
        <DaySelect label="送达日期：" :required="true" v-model="form.endDate">
        </DaySelect>
        <AreaSelect
          :required="true"
          label="收货地址："
          v-model="form.eventOrigin"
          @change="areaChange"
        >
        </AreaSelect>
        <van-field
          required
          v-if="showType === 3"
          :value="form.receiverName || form.receiver"
          label="接收方："
          readonly
        />
        <div v-else>
          <van-field name="switch" label="自定义接收方" v-if="showType !== 3">
            <template #input>
              <van-switch
                v-model="receiverInputType"
                size="20"
                @change="eventOriginChange"
              />
            </template>
          </van-field>
          <van-field
            required
            v-if="receiverInputType"
            v-model="form.receiver"
            label="接收方名称："
            placeholder="自定义接收方名称"
            :rules="[{ required: true, message: '请填写接收方名称' }]"
          />
          <van-field
            required
            v-if="
              !receiverInputType &&
              (!form.eventOrigin || form.eventOrigin === '')
            "
            v-model="form.receiverName"
            label="接收方："
            readonly
            placeholder="选择接收方"
            :rules="[{ required: true, message: '请先选择收货地址' }]"
          />
          <Select
            ref="receiver"
            v-if="
              !receiverInputType && form.eventOrigin && form.eventOrigin !== ''
            "
            v-model="form.receiverName"
            url="/system/organ/getByAddress"
            :params="{ address: form.eventOrigin, type: 0 }"
            :itemScreen="{ key: 'type', value: 0 }"
            keys="name"
            showName="name"
            :required="true"
            label="接收方："
            :searchMode="true"
            @change="receiverChange"
          >
          </Select>
        </div>
        <van-field
          v-model="form.rcvDetailAddr"
          @blur="rcvAddrChange"
          label="详细地址："
          placeholder="详细地址"
          :rules="[{ required: false, message: '请填写详细地址' }]"
        />
        <van-field
          v-model="form.contacts"
          label="联系人："
          placeholder="联系人"
          :rules="[{ required: false, message: '请填写联系人' }]"
        />
        <van-field
          v-model="form.phone"
          label="联系电话："
          placeholder="联系电话"
          :rules="[{ required: false, message: '请填写联系电话' }]"
        />

        <van-field
          v-model="form.independentCode"
          label="调拨函编号："
          placeholder="调拨函编号"
          :rules="[{ required: false, message: '请填写调拨函编号' }]"
        />

        <van-field
          v-model="form.independentName"
          label="事项名称："
          placeholder="事项名称"
          :rules="[{ required: false, message: '请填写事项名称' }]"
        />

        <Select
          v-model="form.eventType"
          url="/system/dict/list/table"
          :params="{ code: 'zhlx' }"
          keys="code"
          showName="name"
          :required="true"
          label="事项类型："
        >
        </Select>
        <Select
          v-model="form.eventLevel"
          url="/system/dict/list/table"
          :params="{ code: 'zhjb' }"
          keys="code"
          showName="name"
          :required="true"
          label="事项级别："
        >
        </Select>
        <van-field
          v-model="form.remark"
          rows="2"
          autosize
          label="调拨备注："
          type="textarea"
          maxlength="250"
          placeholder="请输入备注内容"
          show-word-limit
        />
      </div>
      <div class="content c2" :class="showType === 3 ? 'dis' : 'nodis'">
        <h3>2.调拨物资列表</h3>

        <div class="emm_list_box">
          <van-badge
            v-for="(row, index) in form.directiveDetails"
            :key="index"
            :content="index + 1"
            color="#1989fa"
          >
            <div class="emm_item">
              <van-field
                v-model="form.directiveDetails[index].alias"
                label="物资品名："
                readonly
              />
              <van-field
                v-model="form.directiveDetails[index].brandName"
                label="品牌："
                readonly
              />
              <van-field
                v-model="form.directiveDetails[index].modelName"
                label="型号："
                readonly
              />
              <van-field
                v-model="form.directiveDetails[index].specifications"
                label="辅助属性："
                readonly
              />
              <!-- <Selects
                v-model="form.directiveDetails[index].specifications"
                url="/emm/specification/list"
                :params="{
                  classificationCode:
                    form.directiveDetails[index].classificationCode,
                  emmCode: form.directiveDetails[index].emmCode,
                }"
                keys="code"
                showName="name"
                :required="true"
                label="辅助属性："
              >
              </Selects> -->
              <van-field
                required
                v-model="form.directiveDetails[index].allocateQty"
                label="本次调拨数："
                type="digit"
                placeholder="本次调拨数"
                :rules="[
                  {
                    required: true,
                    message: '请填写本次调拨数量',
                  },
                ]"
              />
              <van-field
                v-model="form.directiveDetails[index].stockNum"
                label="库存数量："
                readonly
                v-if="showType !== 3"
              />
              <Select
                :disabled="true"
                v-model="form.directiveDetails[index].provider"
                :dataList="supplierList"
                keys="clientId"
                showName="clientName"
                :required="false"
                label="生产厂家："
              >
              </Select>
              <van-field
                v-model="form.directiveDetails[index].productDate"
                label="生产日期："
                readonly
              />
              <van-field
                v-model="form.directiveDetails[index].unit"
                label="计量单位："
                readonly
              />
              <van-field
                v-model="form.directiveDetails[index].price"
                label="单价(元)："
                readonly
              />
              <Select
                :disabled="true"
                v-model="form.directiveDetails[index].manageMode"
                :dataList="[
                  { name: '储备', code: 1 },
                  { name: '配备', code: 2 },
                ]"
                keys="code"
                showName="name"
                :required="false"
                label="管理方式："
              >
              </Select>
              <van-field
                v-model="form.directiveDetails[index].stCode"
                label="库房："
                readonly
              />
              <van-field
                v-model="form.directiveDetails[index].locCode"
                label="库位："
                readonly
              />
              <div class="btn_box">
                <van-button
                  v-if="showType !== 3"
                  type="danger"
                  block
                  size="small"
                  icon="delete"
                  native-type="button"
                  color="linear-gradient(to right, #ff6034, #ee0a24)"
                  @click="emmListDel(index)"
                  >删除此物资</van-button
                >
              </div>
            </div>
          </van-badge>
        </div>
        <EmmSelect
          ref="emmSelect"
          v-model="form.directiveDetails"
          :disabled="showType === 3"
        ></EmmSelect>
      </div>
      <div class="content c3">
        <h3>3.物流装车明细</h3>
        <van-badge :content="form.traceList.length" style="width: 100%">
          <van-button
            block
            type="warning"
            native-type="button"
            icon="logistics"
            @click="wlPageShowClick"
            >物流装车明细</van-button
          >
        </van-badge>
        <van-popup
          position="bottom"
          round
          v-model="wlPageShow"
          close-on-popstate
        >
          <WlPageIndex
            @wlPageClose="wlPageShow = false"
            v-model="form.traceList"
            :emmList="form.directiveDetails"
            :type="showType"
          ></WlPageIndex>
        </van-popup>
      </div>
      <div class="content c4">
        <h3>4.调拨凭证</h3>
        <Uploader
          v-model="form.applyAttachment"
          :disabled="showType === 3"
        ></Uploader>
      </div>
      <van-button
        v-if="showType !== 3"
        round
        block
        type="primary"
        native-type="submit"
        style="width: 80%; margin: 15px auto"
        >提 交</van-button
      >
    </van-form>
  </div>
</template>
<script>
import WlPageIndex from "./wl_index.vue";
export default {
  components: { WlPageIndex },
  props: ["showType", "showData"],
  data() {
    return {
      wlPageShow: false,
      supplierList: [],
      form: {
        applyAttachment: "", //申请函附件
        manifestAttachment: "", //物资清单附件
        independentCode: "", //调令号
        orderType: "02", //指令类型
        eventOrigin: "", //发生地
        receiverName: "",
        receiver: "", //接受方
        contacts: "", //接受方联系人
        phone: "", //接受方联系人电话
        rcvDetailAddr: "", //接受方收货地址
        eventType: "00", //灾害类型
        eventLevel: "00", //灾害级别
        storageLevel: "", //物资性质
        endDate: "", //送达日期
        enableAutomatic: 0, //智慧调拨
        warehouseId: "", //调运库点
        warehouseName: "", //调运库点
        remark: "",
        organName: "",
        directiveDetails: [],
        traceList: [],
        type: "01",
      },
      receiverInputType: false,
    };
  },
  created() {},
  mounted() {
    this.into();
  },
  methods: {
    into() {
      if (this.showType > 1) {
        this.getData(this.showData);
      } else {
        this.getWerehouseInfo();
        this.setInfo();
      }
      this.getSupplierList();
    },
    setInfo() {
      this.form.endDate = new Date();
      let userInfo = this.$util.get("userInfo");
      this.form.organId = userInfo.unitCode;
      this.form.organName = userInfo.unitName;
      this.form.storageLevel = this.$util.get("warehouseLevel");
      this.$refs.emmSelect.initData(this.form);
      console.log(userInfo);
    },
    getSupplierList() {
      this.$http
        .get("/emm/clientInfo/pageList", { limit: 999 }, this)
        .then((res) => {
          this.supplierList = res.data.records;
        });
    },
    wlPageShowClick() {
      if (this.form.directiveDetails.length < 1) {
        return this.$msg.info("请先添加物资！");
      }
      this.wlPageShow = true;
    },
    rcvAddrChange() {
      let city = this.form.eventOrigin;
      let detail = this.form.rcvDetailAddr;
      if (!city || city === "") {
        return;
      }
      if (!detail || detail === "") {
        return;
      }
      let address = city.replaceAll("/", "") + detail;
      try {
        var geocoder = new TMap.service.Geocoder(); // 新建一个正逆地址解析类
        let that = this;
        geocoder.getLocation({ address }).then((result) => {
          console.log("getLocation", result);
          if (result.status === 0 && result.result.location.lng) {
            that.form.endLocation =
              result.result.location.lng + "," + result.result.location.lat;
          } else {
            this.$msg.info("地址转坐标服务异常(01)");
          }
        });
      } catch {
        this.$msg.info("地址转坐标服务异常(02)");
      }
    },
    areaChange(val) {
      console.log("area", val);
      this.form.endLocation = val[1].lan + "," + val[1].lat;
      console.log("area", val, this.form.endLocation);
      this.eventOriginChange();
    },
    eventOriginChange() {
      console.log(111, this.form.eventOrigin);
      //收货地区发生变化
      //this.$refs.receiver.clear(); //改变地址后重新获取接收方列表
      this.form.receiver = "";
      this.form.receiverName = "";
      this.form.contacts = "";
      this.form.phone = "";
      this.form.rcvDetailAddr = "";
    },
    receiverChange(val) {
      //接收方发生变化
      console.log("receiverChange", val);
      this.form.receiver = val.code;
      this.form.contacts = val.contact;
      this.form.phone = val.tel;
      this.form.rcvDetailAddr =
        (val.address ? val.address.replaceAll("/", "") : "") +
        (val.detailAddr ? val.detailAddr : "");
    },
    getData(data) {
      this.$http
        .get("/emm/independent/getDetail", {
          independentId: data.independentId,
          warehouseId: data.warehouseId,
        })
        .then((res) => {
          res.data.directiveDetails =
            res.data.directiveDetails || res.data.independentAllocateDetails;
          res.data.directiveDetails.forEach((item) => {
            item.modelName = item.modelName || item.model;
            item.brandName = item.brandName || item.brand;
          });
          this.form = res.data;
        });
    },
    getWerehouseInfo() {
      this.$http.get("/emm/warehouseInfo/list", {}).then((res) => {
        this.form.warehouseId = res.data[0].warehouseId;
        this.form.warehouseName = res.data[0].warehouseName;
        console.log(this.form);
      });
    },
    back() {
      this.$emit("close");
    },
    emmListDel(index) {
      let that = this;
      this.$dialog
        .confirm({
          title: "确认删除此物资吗？",
          message: "（删除物资后，注意删除关联的车载物资）",
        })
        .then(() => {
          that.form.directiveDetails.splice(index, 1);
          if (that.form.directiveDetails.length < 1) {
            that.form.traceList = [];
          }
        });
    },

    onSubmit(values) {
      console.log("submit", this.form);
      if (this.form.directiveDetails.length < 1) {
        return this.$msg.info("调拨物资列表不能为空");
      }
      if (this.form.traceList.length < 1) {
        return this.$msg.info("物流装车明细列表不能为空");
      }
      let url = "";
      if (this.showType > 1) {
        url = "/emm/independent/add"; //更新
      } else {
        url = "/emm/independent/add"; //新增
      }
      if (!this.form.endLocation) {
        return this.$msg.info("地址转坐标服务异常");
      }
      this.$http.post(url, this.form).then((res) => {
        if (res.code === 0) {
          this.$msg.success("提交成功");
          this.back();
        } else {
          this.$msg.error("提交失败:" + res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.page_diaobo_add {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #f6f9f8;
  .container {
    width: 100vw;
    height: calc(100vh - 46px);
    overflow-x: hidden;
    overflow-y: auto;
    .content {
      background: #fff;
      margin: 10px 0;
      padding: 10px 16px;
      h3 {
        margin-bottom: 10px;
      }
      &.c2 {
        background: #f6f9f8;
      }
      .emm_list_box {
        width: 90%;
        margin: 15px auto;
        .van-badge__wrapper {
          width: 100%;
        }
        .emm_item {
          width: 100%;
          margin-bottom: 15px;
          background-color: #fff;
          border-radius: 7px;
          overflow: hidden;
          box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
          .van-cell {
            padding: 5px 16px;
          }
          .btn_box {
            display: flex;
            justify-content: flex-end;
          }
        }
      }
    }
  }
  .van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
